import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,convertiValuta,convertiColore,convertiColoreLaccio,convertiTaglia,convertiTipoAccessori,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faDollarSign,faX,faStore, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
/* global DevExpress */
function Accessori() {
    function openContoFormPopup(initialData, aggiunta) {
  const popup = $("#popupContoEdit").dxPopup("instance");

  popup.option("contentTemplate", function() {
    const container = $("<div>");
    container.dxForm({
      formData: initialData,
      labelLocation: "top",
      items: [
         {
      dataField: "data",
      label: { text: "Data" },
      template: function(formItem, itemElement) {
        itemElement.empty();

        // Converto il valore iniziale in Date se è ISO:
        let initialValue = formItem.editorOptions?.value || formItem.component.option("formData").data;
        if (typeof initialValue === "string") {
          initialValue = new Date(initialValue);
        }

        $("<div>").appendTo(itemElement).dxDateBox({
          type: "date",
          displayFormat: "dd/MM/yyyy",
          value: initialValue,
          onValueChanged: function(e) {
             const form = formItem.component; // usa il componente passato
    const fd = form.option("formData");
    fd.data = e.value ? e.value.toISOString().slice(0,10) : null;
    form.option("formData", fd);
          }
        });
      }
    },
          { dataField: "nome" },
        { dataField: "note" },

        {
          itemType: "button",
          horizontalAlignment: "right",
          buttonOptions: {
            text: "Salva",
            type: "success",
            onClick: async function() {
              const form = container.dxForm("instance");
              const data = form.option("formData");
              let richiesta;
              const dati= {billcustomer:data.nome,billdate:convertDate(DateTime.fromISO(data.data)),
                billnotes:data.note}
              if (aggiunta){
                   richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                        azione:'setBillItem'
                   })
                  const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.push({id:richiesta.billid,text:data.nome})
                  instance.option("dataSource",datas)
              }
              else {
                  richiesta= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                      setId:$("#val_conto").dxLookup("instance").option("value"),
                        azione:'setBillItem'
                   })
                    const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.find(x => {
                        if (x.id === instance.option("value")) x.text=data.nome
                    })
                  instance.option("dataSource",datas)
              }
              popup.hide();
            }
          }
        }
      ]
    });
    return container;
  });

  popup.show();
}
let editMode=null
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
async function modificaStatus(datiPrima) {

    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `Sei sicuro di volere riportare l'accessorio in magazzino?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontWeight = "bold";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#modificaMagazzino").dxPopup("instance").option( "title",`Conferma ritorno in magazzino`);
    $("#modificaMagazzino").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaMagazzino").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () { $("#modificaMagazzino").dxPopup("instance").hide();
        const dati_n={billid:0,"accessorysold":0,"accessorysoldprice":null,"accessorysoldcustomer":null,"accessorysoldadvance":null,"accessorysolddate":null,"accessorysoldcurrency":null,}
        var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    setId:datiPrima,
                    azione:'setAccessoryItem'})

        if (richiesta){
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"accessoriesfrom":inizioP,"accessoriesto":fineP},
                        azione: "getAccessoryItems",
                    })
            let formattedRowsMagazzino=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===0){
                formattedRowsMagazzino.push({"conto":maglia.billid,"quantita":null,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":maglia.accessorysolddate,"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        let formattedRowsVendute=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===1){
                formattedRowsVendute.push({"conto":maglia.billid,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        $("#gridContainerMagazzino").dxDataGrid("instance").option("dataSource",formattedRowsMagazzino)
        }
        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaMagazzino").dxPopup("instance").hide();}
      },
    }],)
    $("#modificaMagazzino").dxPopup("instance").show();
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaMaglie() {
    useEffect(()=>{
        const fetchDati= async () => {
            $("#loadingOverlay").show()
            $("#gridContainerMagazzino").addClass("grid-container-hidden");
            const allineamento="center"
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"accessoriesfrom":inizioP,"accessoriesto":fineP},
                        azione: "getAccessoryItems",
                    })
            const conti=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getBillItems",
                    })
        let formattedRowsMagazzino=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===0){
                formattedRowsMagazzino.push({"conto":maglia.billid,"quantita":null,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":maglia.accessorysolddate,"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        let formattedRowsVendute=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===1){
                formattedRowsVendute.push({"conto":maglia.billid,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        $("#gridContainerMagazzino").dxDataGrid({
            dataSource:formattedRowsMagazzino,
            columns:[
            {dataField:"tipo",hidingPriority:1,alignment:"center",caption:"Tipo Accessorio",customizeText:function (e){return convertiTipoAccessori(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":"Maglietta"},{"id":2,"name":"Cappello"},{"id":3,"name":"Laccio per Occhiali"}]
            $("#val_tipo").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            let dati_ut
            if (e.value===1){
                 dati_ut=[{"id":1,"name":"Rossa"},{"id":2,"name":"Gialla"},{"id":3,"name":"Blu"},{"id":4,"name":"Rosa"},{"id":5,"name":"Bianca"},{"id":6,"name":"Verde"},{"id":7,"name":"Nera"},{"id":8,"name":"Beige"},{"id":9,"name":"Azzurra N"}]
            }
            else if (e.value===3){
                 dati_ut=[{"id":1,"name":"Rosso"},{"id":2,"name":"Verde"},{"id":3,"name":"Blu"},{"id":4,"name":"Arancione"},{"id":5,"name":"Nero"}]
            }
            $("#val_colore").dxSelectBox("instance").option("dataSource",dati_ut)
            }})
          }},
          {dataField:"quantita",visible:false,
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#val_quantita").length===0) {
                $('<div id="val_quantita"></div>').appendTo(cellElement)
            }
            $("#val_quantita").dxNumberBox({showSpinButtons: true,step:10,min:0,value:0,format:"#0.##", onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"taglia",hidingPriority:2,alignment:"center",caption:"Taglia Accessorio",customizeText:function (e){return convertiTaglia(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_taglia").length===0) {
                $('<div id="val_taglia"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":5,"name":"XS"},{"id":1,"name":"S"},{"id":2,"name":"M"},{"id":3,"name":"L"},{"id":4,"name":"XL"}]
            $("#val_taglia").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},
            {dataField:"colore",hidingPriority:3,alignment:"center",caption:"Colore Accessorio",calculateDisplayValue: function(rowData){return rowData.tipo===1?convertiColore(rowData.colore):convertiColoreLaccio(rowData.colore)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_colore").length===0) {
                $('<div id="val_colore"></div>').appendTo(cellElement)
            }
            let dati_ut
            if (cellInfo.data.tipo===1){
                 dati_ut=[{"id":1,"name":"Rossa"},{"id":2,"name":"Gialla"},{"id":3,"name":"Blu"},{"id":4,"name":"Rosa"},{"id":5,"name":"Bianca"},{"id":6,"name":"Verde"},{"id":7,"name":"Nera"},{"id":8,"name":"Beige"},{"id":9,"name":"Azzurra N"}]
            }
            else if (cellInfo.data.tipo===3){
                 dati_ut=[{"id":1,"name":"Rosso"},{"id":2,"name":"Verde"},{"id":3,"name":"Blu"},{"id":4,"name":"Arancione"},{"id":5,"name":"Nero"}]
            }

            $("#val_colore").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},

            {dataField:"venduta",visible:false},
            {dataField:"prezzo",visible:false,
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.data.prezzo,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"pagato",visible:false,
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#val_pagato").length===0) {
                $('<div id="val_pagato"></div>').appendTo(cellElement)
            }
            $("#val_pagato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:0,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"valuta",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_prezzo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#val_pagato").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          }},
                  {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("MODIFICA → id:", val);
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        console.log("AGGIUNGI → apri popup nuovo");
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("ELIMINA → id:", val);
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
            {dataField:"prezzoVendita",visible:false,
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#val_prezzo").length===0) {
                $('<div id="val_prezzo"></div>').appendTo(cellElement)
            }
            $("#val_prezzo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:0,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
          {
            dataField: "dataVendita",
            visible:false,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          }},
          {dataField:"cliente",
            visible:false,},
            {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => {
                      editMode="modifica"
                      cellInfo.component.editRow(cellInfo.rowIndex)}}
                    />
                  );
                },
              },
              {
                hint: "Venduta",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faDollarSign}
                      color="#007bff"
                      onClick={() => {
                      editMode="vendita"
                      cellInfo.data.venduta=1
                      cellInfo.component.editRow(cellInfo.rowIndex)}}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
            ],
         onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerMagazzino").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          
        },
        onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.accessoryid,
        azione:'delAccessoryItem',
        return_data:false})
    if (richiesta) {
        const message = `Articolo eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);}


},

        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
          let dataTipo = [];
          for (let i = 1; i <= 3; i++) {
            dataTipo.push({ ID: i, nome: convertiTipoAccessori(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
          else if (e.parentType === "filterRow" && e.dataField === "taglia"){
          let dataTipo = [];
          for (let i = 1; i <= 4; i++) {
            dataTipo.push({ ID: i, nome: convertiTaglia(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            }
          }
          else if (e.parentType === "filterRow" && e.dataField === "colore"){
          let dataTipo = [];
          for (let i = 1; i <= 6; i++) {
            dataTipo.push({ ID: i, nome: convertiColore(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
        },
             onRowInserting: async function (e) {
    const gridElement = $("#gridContainerMagazzino"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={billid:e.data.conto?e.data.conto:0,'accessorysize':e.data.taglia,'accessorycolor':e.data.colore,'accessorysolddate':convertDate(DateTime.fromISO(e.data.dataVendita)),'accessorysoldprice':e.data.prezzoVendita,'accessoryprice':e.data.prezzo,'accessorysoldcurrency':e.data.valuta,'accessorysoldadvance':e.data.pagato,'accessorysoldcustomer':e.data.cliente,'accessorysold':e.data.venduta, 'accessorytype':e.data.tipo};
    let richiesta
     for (let i = 0; i <e.data.quantita; i++) {
     richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati_n,
        azione:'setAccessoryItem'})}
        if (richiesta) {
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"accessoriesfrom":inizioP,"accessoriesto":fineP},
                        azione: "getAccessoryItems",
                    })
        formattedRowsMagazzino=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===0){
                formattedRowsMagazzino.push({"conto":maglia.billid,"quantita":null,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":maglia.accessorysolddate,"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        formattedRowsVendute=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===1){
                formattedRowsVendute.push({"conto":maglia.billid,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        $("#gridContainerMagazzino").dxDataGrid("instance").option("dataSource",formattedRowsMagazzino)

        const message = `Accessorio modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerMagazzino',
        },}, "success", 1000);
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerMagazzino"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={billid:e.data.conto?e.data.conto:0,'accessorysize':e.data.taglia,'accessorycolor':e.data.colore,'accessorysolddate':convertDate(DateTime.fromISO(e.data.dataVendita)),'accessorysoldprice':e.data.prezzoVendita,'accessoryprice':e.data.prezzo,'accessorysoldcurrency':e.data.valuta,'accessorysoldadvance':e.data.pagato,'accessorysoldcustomer':e.data.cliente,'accessorysold':e.data.venduta, 'accessorytype':e.data.tipo};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.accessoryid,
        valori:dati_n,
        azione:'setAccessoryItem'})
        if (richiesta) {
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"accessoriesfrom":inizioP,"accessoriesto":fineP},
                        azione: "getAccessoryItems",
                    })
        formattedRowsMagazzino=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===0){
                formattedRowsMagazzino.push({"conto":maglia.billid,"quantita":null,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":maglia.accessorysolddate,"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        formattedRowsVendute=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===1){
                formattedRowsVendute.push({"conto":maglia.billid,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        $("#gridContainerMagazzino").dxDataGrid("instance").option("dataSource",formattedRowsMagazzino)

        const message = `Accessorio modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerMagazzino',
        },}, "success", 1000);
        }
    },
onInitNewRow: function (e) {
  editMode = "new"; // se ti serve altrove

  // Personalizza direttamente l'editor popup qui
  const grid = e.component;

  setTimeout(() => {
    grid.option("editing.popup.title", "Aggiungi maglia");
    grid.option("editing.form.items", [
      { dataField: "tipo", label: { text: "Tipo accessorio" } },
      { dataField: "taglia", label: { text: "Taglia" } },
      { dataField: "colore", label: { text: "Colore" } },
      { dataField: "quantita", label: { text: "Numero accessori" } },
    ]);
  }, 0);
},
        onEditingStart: function (e) {
    const formInstance = e.component.option("editing.form");

    if (editMode === "modifica") {
      e.component.option("editing.popup.title", "Modifica maglia");
      e.component.option("editing.form.items", [
         { dataField: "tipo", label: { text: "Tipo accessorio" } },
        { dataField: "taglia", label: { text: "Taglia" } },
        { dataField: "colore", label: { text: "Colore" } },
        { dataField: "prezzo", label: { text: "Prezzo accessorio" } },
      ]);
    } else if (editMode === "vendita") {
      e.component.option("editing.popup.title", "Registra vendita");
      e.component.option("editing.form.items", [
        { dataField: "cliente", label: { text: "Venduto a" } },
        { dataField: "dataVendita", label: { text: "Data" }},
        { dataField: "prezzoVendita", label: { text: "Prezzo" } },
        { dataField: "pagato", label: { text: "Importo pagato" }},
        { dataField: "valuta", label: { text: "Valuta vendita" }},
          { dataField: "conto", label: { text: "Conto" }},
      ]);
    }
  },
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            showTitle:true,
            },
            form: {
      items: [], // inizialmente vuoto, lo riempiamo in base al tipo
    },}
        })
    $("#gridContainerVendute").dxDataGrid({
            dataSource:formattedRowsVendute,
            columns:[
            {dataField:"tipo",alignment:"center",caption:"Tipo Accessorio",hidingPriority:1,
            customizeText:function (e){return convertiTipoAccessori(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valtipo").length===0) {
                $('<div id="vendute_valtipo"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":"Maglietta"},{"id":2,"name":"Cappello"},{"id":3,"name":"Laccio per Occhiali"}]
            $("#vendute_valtipo").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},
                {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("MODIFICA → id:", val);
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        console.log("AGGIUNGI → apri popup nuovo");
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("ELIMINA → id:", val);
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
            {dataField:"taglia",alignment:"center",hidingPriority:2,caption:"Taglia Accessorio",customizeText:function (e){return convertiTaglia(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valtaglia").length===0) {
                $('<div id="vendute_valtaglia"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":5,"name":"XS"},{"id":1,"name":"S"},{"id":2,"name":"M"},{"id":3,"name":"L"},{"id":4,"name":"XL"},]
            $("#vendute_valtaglia").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},
            {dataField:"colore",alignment:"center",hidingPriority:4,caption:"Colore Accessorio",calculateDisplayValue: function(rowData){return rowData.tipo===1?convertiColore(rowData.colore):convertiColoreLaccio(rowData.colore)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valcolore").length===0) {
                $('<div id="vendute_valcolore"></div>').appendTo(cellElement)
            }
            let dati_ut
            if (cellInfo.data.tipo===1){
                 dati_ut=[{"id":1,"name":"Rossa"},{"id":2,"name":"Gialla"},{"id":3,"name":"Blu"},{"id":4,"name":"Rosa"},{"id":5,"name":"Bianca"},{"id":6,"name":"Verde"},{"id":7,"name":"Nera"},{"id":8,"name":"Beige"},{"id":9,"name":"Azzurra N"}]
            }
            else if (cellInfo.data.tipo===3){
                 dati_ut=[{"id":1,"name":"Rosso"},{"id":2,"name":"Verde"},{"id":3,"name":"Blu"},{"id":4,"name":"Arancione"},{"id":5,"name":"Nero"}]
            }
            $("#vendute_valcolore").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},
            {
            dataField: "dataVendita",
            hidingPriority:3,
            sortOrder: "desc",
            customizeText:function (e){
                return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")
            },
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#vendute_valreg").length===0) {
                $('<div id="vendute_valreg"></div>').appendTo(cellElement)
            }
            $("#vendute_valreg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          }},
          {dataField:"cliente",alignment:"center",hidingPriority:7},
            {dataField:"prezzoVendita",alignment:"center",
            hidingPriority:5,
            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valprezzo").length===0) {
                $('<div id="vendute_valprezzo"></div>').appendTo(cellElement)
            }
            $("#vendute_valprezzo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"venduta",visible:false},
            {dataField:"pagato",alignment:"center",hidingPriority:6,

            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valpagato").length===0) {
                $('<div id="vendute_valpagato"></div>').appendTo(cellElement)
            }
            $("#vendute_valpagato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"valuta",

            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valvaluta").length===0) {
                $('<div id="vendute_valvaluta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#vendute_valvaluta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#vendute_valprezzo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#vendute_valpagato").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          }},

            {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => {
                      cellInfo.component.editRow(cellInfo.rowIndex)}}
                    />
                  );
                },
              },
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faStore}
                      color="#007bff"
                      onClick={() => modificaStatus(cellInfo.data.accessoryid)}
                    />
                  );
                },
              },

            ],
          },
            ],
         onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerMagazzino").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)

        },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const anticipo = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.prezzoVendita);

            if (isNaN(anticipo) ||( !isNaN(costo) && Math.abs(anticipo - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              $(e.rowElement).css("background-color", "#ffe6e6")
            }
          }
        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
          let dataTipo = [];
          for (let i = 1; i <= 2; i++) {
            dataTipo.push({ ID: i, nome: convertiTipoAccessori(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
          else if (e.parentType === "filterRow" && e.dataField === "taglia"){
          let dataTipo = [];
          for (let i = 1; i <= 4; i++) {
            dataTipo.push({ ID: i, nome: convertiTaglia(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            }
          }
          else if (e.parentType === "filterRow" && e.dataField === "colore"){
          let dataTipo = [];
          for (let i = 1; i <= 6; i++) {
            dataTipo.push({ ID: i, nome: convertiColore(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
        },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerVendute"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={billid:e.data.conto?e.data.conto:0,'accessorysolddate':convertDate(DateTime.fromISO(e.data.dataVendita)),'accessorysoldprice':e.data.prezzoVendita,'accessorysoldcurrency':e.data.valuta,'accessorysoldadvance':e.data.pagato,'accessorysoldcustomer':e.data.cliente,'accessorysold':e.data.venduta, };
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.accessoryid,
        valori:dati_n,
        azione:'setAccessoryItem'})
        if (richiesta) {
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"accessoriesfrom":inizioP,"accessoriesto":fineP},
                        azione: "getAccessoryItems",
                    })
        formattedRowsMagazzino=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===0){
                formattedRowsMagazzino.push({"conto":maglia.billid,"quantita":null,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":maglia.accessorysolddate,"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        formattedRowsVendute=[]
        for (let maglia of magliette){
            if (maglia.accessorysold===1){
                formattedRowsVendute.push({"conto":maglia.billid,"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
            }
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        $("#gridContainerMagazzino").dxDataGrid("instance").option("dataSource",formattedRowsMagazzino)
        const message = `Accessorio modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerMagazzino',
        },}, "success", 1000);
        }
    },
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: false,
          allowDeleting: false,
          useIcons: true,
          popup: {
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            showTitle:true,
            },
            form: {
      colCount: 1,
            items: [
              {
                itemType: "group",
                colCount: 2,
                items: [
                { dataField: "dataVendita", label: { text: "Data di vendita" } },{ dataField: "cliente", label: { text: "Cliente" }},{ dataField: "prezzoVendita", label: { text: "Prezzo di Vendita" }},{ dataField: "pagato", label: { text: "Prezzo pagato" }},{ dataField: "valuta", label: { text: "Valuta vendita" }},
                 { dataField: "conto", label: { text: "Conto" }},
                ],
              },

            ],
          },
    },
        })
        $("#modificaMagazzino").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
        $("#popupContoEdit").dxPopup({
  width: "90%",
  height: "auto",
  showTitle: true,
  title: "Gestisci conto",
  dragEnabled: false,
  hideOnOutsideClick: true
});
        }
    fetchDati()
    },[])
    return <div>
            <h2>Magliette in magazzino</h2>
            <div id="gridContainerMagazzino"></div>
            <h2>Magliette Vendute</h2>
            <div id="gridContainerVendute"></div>
            <div id="modificaMagazzino" />
           </div>
}
return <div>
            <h1>Analisi vendita magliette</h1>
            <TabellaMaglie/>
     <div id="popupContoEdit"></div>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
        </div>
}
export default Accessori